import { Log } from './log';
import { Product } from './product.interface.ts';

export interface CartProducts extends Log {
    id?: any;

    /**
     * @description Product is a valid LuxuraProduct id
     */
    product: Product;

    /**
     * @description Quantity must be a positive number
     */
    quantity: number;

    /**
     * @description insertedAt  will be date when product is added at cart.
     */
    insertedAt: Date;
}
